import React from 'react';
import type { GameMode } from '@interactive-room';
import { MODE_VISUALS } from '../../theme/designSystem';
import { useTheme } from '../../theme/ThemeContext';

interface StageBackdropProps {
  mode?: GameMode | null;
  variant?: 'stage' | 'field' | 'split';
}

/**
 * Fondo ligero en CPU/GPU: sin blur ni grain en light, animaciones solo en dark.
 */
export function StageBackdrop({ mode, variant = 'stage' }: StageBackdropProps) {
  const { theme } = useTheme();
  const visual = mode ? MODE_VISUALS[mode] : null;
  const isLight = theme === 'light';
  const isField = variant === 'field';

  if (isField) {
    return null;
  }

  if (isLight) {
    return (
      <div
        className="pointer-events-none fixed inset-0 -z-10"
        style={{
          background: visual?.mesh ?? 'var(--sala-mesh)',
          opacity: 0.55,
        }}
        aria-hidden
      />
    );
  }

  return (
    <>
      <div className="sala-grain sala-grain-dark" aria-hidden />

      <div
        className="pointer-events-none fixed inset-0 -z-10"
        style={{ background: visual?.mesh ?? 'var(--sala-mesh)' }}
        aria-hidden
      />

      {variant === 'stage' && (
        <div className="pointer-events-none fixed inset-0 -z-10 sala-grid-lines opacity-30" aria-hidden />
      )}

      {variant === 'stage' && (
        <div
          className="sala-orb sala-orb-a pointer-events-none fixed -z-10"
          style={{ background: visual?.neon ?? 'var(--sala-accent-neon)' }}
          aria-hidden
        />
      )}
    </>
  );
}
